
import { Suspense } from 'react';
import { Ellipsis, DollarSign, NotepadText } from 'lucide-react';
import profileDefault from '../../icons/profile-default.svg'
import CountryFlag from '../../components/countryFlags/countryFlag';



const CRMPreview = () => {

  return (
    <section className="w-[100%] md:w-[100%] mx-auto text-center">
<div className="flex justify-center mx-0 px-0 py-10">
<div className="flex flex-col flex-shrink-0 items-center mr-3 w-64">
    <div className="flex items-center w-full h-8 mb-2 bg-white border border-stone-300 rounded-md px-3">
      <h2 className="text-sm font-medium text-stone-900">
        Research <span className="text-sm">(3)</span>
      </h2>
    </div>
    <div
      className="rounded-md w-full"
    >
      <div
        data-rbd-droppable-id={1}
        data-rbd-droppable-context-id={6}
        className="px-2"      >
        <div
          data-rbd-draggable-context-id={6}
          data-rbd-draggable-id="66d849193efc7c62db1291c2"
          tabIndex={0}
          role="button"
          aria-describedby="rbd-hidden-text-6-hidden-text-52"
          data-rbd-drag-handle-draggable-id="66d849193efc7c62db1291c2"
          data-rbd-drag-handle-context-id={6}
          draggable="false"
          className="min-h-24 p-3 bg-white rounded-md mb-4 shadow relative "
        >
          <div className="flex items-start">
            <div className="flex-1 flex items-start">
            <img src={profileDefault} className="flex-shrink-0 w-10 h-10" alt="Investor profile" />
              <div className="ml-3">
                <h4 className="text-sm text-left font-bold break-words">
                  Yoma Jo Luor
                </h4>
              </div>
            </div>
            <button
              type="button"
              className="w-5 h-5 cursor-pointer ml-3 flex-shrink-0"
              id="radix-:r35:"
              aria-haspopup="menu"
              aria-expanded="false"
              data-state="closed"
            >
              <Ellipsis strokeWidth={1.5} className="w-5 h-5 mr-2" />
            </button>
          </div>
          <div className="absolute bottom-2 right-2">
            <div className="relative inline-block">
            <Suspense fallback={<div></div>}>
            <CountryFlag countryName="Australia" alt="Australia flag" className="w-5" />
            </Suspense>
            </div>
          </div>
        </div>
        <div
          data-rbd-draggable-context-id={6}
          data-rbd-draggable-id="66d849193efc7c62db1291c0"
          tabIndex={0}
          role="button"
          aria-describedby="rbd-hidden-text-6-hidden-text-52"
          data-rbd-drag-handle-draggable-id="66d849193efc7c62db1291c0"
          data-rbd-drag-handle-context-id={6}
          draggable="false"
          className="min-h-24 p-3 bg-white rounded-md mb-4 shadow relative "
        >
          <div className="flex items-start">
            <div className="flex-1 flex items-start">
            <img src={profileDefault} className="flex-shrink-0 w-10 h-10" alt="Investor profile" />
              <div className="ml-3">
                <h4 className="text-sm text-left font-bold break-words">
                Aurora Equity Partners
                </h4>
              </div>
            </div>
            <button
              type="button"
              className="w-5 h-5 cursor-pointer ml-3 flex-shrink-0"
              id="radix-:r37:"
              aria-haspopup="menu"
              aria-expanded="false"
              data-state="closed"
            >
              <Ellipsis strokeWidth={1.5} className="w-5 h-5 mr-2" />
            </button>
          </div>
          <div className="absolute bottom-2 right-2">
            <div className="relative inline-block">
            <Suspense fallback={<div></div>}>
            <CountryFlag countryName="United States" alt="USA flag" className="w-5" />
            </Suspense>
            </div>
          </div>
          <div className="flex items-center mt-6 mr-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-notepad-text w-4 h-4 mr-2"
            >
              <path d="M8 2v4" />
              <path d="M12 2v4" />
              <path d="M16 2v4" />
              <rect width={16} height={18} x={4} y={4} rx={2} />
              <path d="M8 10h6" />
              <path d="M8 14h8" />
              <path d="M8 18h5" />
            </svg>
            <p className="mx-0 my-0 text-left text-sm text-clr9">
              We agreed to have a call on Tuesday
            </p>
          </div>
        </div>
        <div
          data-rbd-draggable-context-id={6}
          data-rbd-draggable-id="66d849193efc7c62db129233"
          tabIndex={0}
          role="button"
          aria-describedby="rbd-hidden-text-6-hidden-text-52"
          data-rbd-drag-handle-draggable-id="66d849193efc7c62db129233"
          data-rbd-drag-handle-context-id={6}
          draggable="false"
          className="min-h-24 p-3 bg-white rounded-md mb-4 shadow relative "
        >
          <div className="flex items-start">
            <div className="flex-1 flex items-start">
            <img src={profileDefault} className="flex-shrink-0 w-10 h-10" alt="Investor profile" />
              <div className="ml-3">
                <h4 className="text-sm text-left font-bold break-words">
                  NorthBridge Ventures
                </h4>
              </div>
            </div>
            <button
              type="button"
              className="w-5 h-5 cursor-pointer ml-3 flex-shrink-0"
              id="radix-:r39:"
              aria-haspopup="menu"
              aria-expanded="false"
              data-state="closed"
            >
              <Ellipsis strokeWidth={1.5} className="w-5 h-5 mr-2" />
            </button>
          </div>
          <div className="absolute bottom-2 right-2">
            <div className="relative inline-block">
            <Suspense fallback={<div></div>}>
            <CountryFlag countryName="Brazil" alt="Brazil flag" className="w-5" />
            </Suspense>
            </div>
          </div>
          <div className="flex items-center mt-6 mr-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-notepad-text w-4 h-4 mr-2"
            >
              <path d="M8 2v4" />
              <path d="M12 2v4" />
              <path d="M16 2v4" />
              <rect width={16} height={18} x={4} y={4} rx={2} />
              <path d="M8 10h6" />
              <path d="M8 14h8" />
              <path d="M8 18h5" />
            </svg>
            <p className="mx-0 my-0 text-left text-sm text-clr9">
              The fund is asking for extra docs.
            </p>
          </div>
        </div>
        <button className="cursor-pointer inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-stone-50 shadow-sm hover:bg-stone-200 h-8 rounded-md px-3 text-xs w-full">
          Add more investors to your CRM
        </button>
      </div>
    </div>
  </div>
  <div className="flex flex-col flex-shrink-0 items-center mr-3 w-64">
    <div className="flex items-center w-full h-8 mb-2 bg-white border border-stone-300 rounded-md px-3">
      <h2 className="text-sm font-medium text-stone-900">
        In progress <span className="text-sm">(2)</span>
      </h2>
    </div>
    <div
      className="rounded-md w-full"
    >
      <div
        data-rbd-droppable-id={2}
        data-rbd-droppable-context-id={6}
        className="px-2"
      >
        <div
          data-rbd-draggable-context-id={6}
          data-rbd-draggable-id="66d849193efc7c62db129230"
          tabIndex={0}
          role="button"
          aria-describedby="rbd-hidden-text-6-hidden-text-52"
          data-rbd-drag-handle-draggable-id="66d849193efc7c62db129230"
          data-rbd-drag-handle-context-id={6}
          draggable="false"
          className="min-h-24 p-3 bg-white rounded-md mb-4 shadow relative "
        >
          <div className="flex items-start">
            <div className="flex-1 flex items-start">
            <img src={profileDefault} className="flex-shrink-0 w-10 h-10" alt="Investor profile" />
              <div className="ml-3">
                <h4 className="text-sm text-left font-bold break-words">BlueSprout Investments</h4>
              </div>
            </div>
            <button
              type="button"
              className="w-5 h-5 cursor-pointer ml-3 flex-shrink-0"
              id="radix-:r3b:"
              aria-haspopup="menu"
              aria-expanded="false"
              data-state="closed"
            >
              <Ellipsis strokeWidth={1.5} className="w-5 h-5 mr-2" />
            </button>
          </div>
          <div className="absolute bottom-2 right-2">
            <div className="relative inline-block">
            <Suspense fallback={<div></div>}>
            <CountryFlag countryName="Spain" alt="Spain flag" className="w-5" />
            </Suspense>
            </div>
          </div>
          <div className="flex items-center mt-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-dollar-sign w-4 h-4 mr-2"
            >
              <line x1={12} x2={12} y1={2} y2={22} />
              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
            </svg>
            <p className="mx-0 my-0 text-sm">24,300.00</p>
          </div>
        </div>
        <div
          data-rbd-draggable-context-id={6}
          data-rbd-draggable-id="66d849193efc7c62db12921b"
          tabIndex={0}
          role="button"
          aria-describedby="rbd-hidden-text-6-hidden-text-52"
          data-rbd-drag-handle-draggable-id="66d849193efc7c62db12921b"
          data-rbd-drag-handle-context-id={6}
          draggable="false"
          className="min-h-24 p-3 bg-white rounded-md mb-4 shadow relative "
        >
          <div className="flex items-start">
            <div className="flex-1 flex items-start">
            <img src={profileDefault} className="flex-shrink-0 w-10 h-10" alt="Investor profile" />
              <div className="ml-3">
                <h4 className="text-sm text-left font-bold break-words">AGate Capital</h4>
              </div>
            </div>
            <button
              type="button"
              className="w-5 h-5 cursor-pointer ml-3 flex-shrink-0"
              id="radix-:r3d:"
              aria-haspopup="menu"
              aria-expanded="false"
              data-state="closed"
            >
              <Ellipsis strokeWidth={1.5} className="w-5 h-5 mr-2" />
            </button>
          </div>
          <div className="absolute bottom-2 right-2">
            <div className="relative inline-block">
            <Suspense fallback={<div></div>}>
            <CountryFlag countryName="Canada" alt="Canada flag" className="w-5" />
            </Suspense>
            </div>
          </div>
          <div className="flex items-center mt-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-dollar-sign w-4 h-4 mr-2"
            >
              <line x1={12} x2={12} y1={2} y2={22} />
              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
            </svg>
            <p className="mx-0 my-0 text-sm">11,000.00</p>
          </div>
        </div>
        <button className="cursor-pointer inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 border border-input bg-stone-50 shadow-sm hover:bg-stone-200 h-8 rounded-md px-3 text-xs w-full">
          Contact and pitch investors
        </button>
      </div>
    </div>
  </div>
</div>

  </section>
  );
};

export default CRMPreview;
